import { Box, Text, VStack, HStack, Badge, Divider } from "@chakra-ui/layout";
import { FormControl, FormLabel, useColorModeValue } from "@chakra-ui/react";

import { ProductStructure, ProductType } from "doxecure-commons/doxecureTypes";

import { G1Input } from "@components/G1Input";
import { G1Icon } from "@/utils/icons";

interface SubscriptionStepProps {
    partnerCode?: string;
    subscriptionProduct?: ProductStructure;
    packProducts?: ProductStructure[];
    onPartnerCodeChange: (code: string) => void;
}

export const SubscriptionStep = (props: SubscriptionStepProps) => {
    const {
        subscriptionProduct,
        packProducts,
        partnerCode,
        onPartnerCodeChange,
    } = props;

    const collaboratorProduct = packProducts?.find(p => p.type === ProductType.Collaborator);
    const textColor = useColorModeValue("gray.100", "gray.400");
    const titleColor = useColorModeValue("blue.700", "blue.100");
    const priceColor = useColorModeValue("blue.600", "blue.200");
    const dividerColor = useColorModeValue("blue.200", "blue.700");
    const featureIconBg = useColorModeValue("blue.400", "blue.300"); // 👈 sorti du map


    return (
        <VStack spacing={3}>
            <Box
                width="100%"
                borderWidth="2px"
                borderRadius="xl"
                borderColor="blue.400"
                bg="blue.400"
                p={{ base: 4, md: 8 }}
                position="relative"
                overflow="hidden"
            >
                <Badge
                    position="absolute"
                    top={4}
                    right={4}
                    colorScheme="blue"
                    variant="solid"
                    borderRadius="full"
                    px={3}
                    py={1}
                    fontSize="xs"
                    textTransform="uppercase"
                    letterSpacing="wide"
                >
                    Offre unique
                </Badge>

                <VStack align="flex-start" spacing={1} mb={6}>
                    <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color={titleColor}>{subscriptionProduct?.label}</Text>
                    <Text fontSize={{ base: "xs", md: "sm" }} color={textColor} fontStyle="italic">{subscriptionProduct?.description}</Text>
                    <HStack align="baseline" spacing={1} mt={2}>
                        <Text fontSize={{ base: "3xl", md: "4xl" }} fontWeight="extrabold" color={priceColor}>{subscriptionProduct?.price}€</Text>
                        <Text fontSize="sm" color={textColor}>HT / an</Text>
                    </HStack>
                </VStack>

                <Divider borderColor={dividerColor} mb={4} />

                <VStack align="flex-start" spacing={2}>
                    {subscriptionProduct?.features.map((feature) => (
                        <HStack key={feature} spacing={3}>
                            <Box
                                borderRadius="full"
                                bg={featureIconBg}
                                p={1}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <G1Icon.Check color="white" />
                            </Box>
                            <Text className="btn-text" fontSize={["xs", "sm"]} color={textColor}>
                                {feature}
                            </Text>
                        </HStack>
                    ))}
                </VStack>
            </Box>

            <FormControl>
                <FormLabel fontSize="1.25em">Code partenaire</FormLabel>
                <G1Input
                    component="connection.form"
                    value={partnerCode}
                    textTransform="uppercase"
                    onChange={(e) => onPartnerCodeChange(e.target.value)}
                />
            </FormControl>

            <Box mt={5} p={4} bg="orange.900" border="1px solid" borderColor="orange.600" borderRadius="md">
                <Text fontSize="md" color="orange.100" lineHeight="1.7">
                    ⚠️ Durant la période d'essai, vous avez la possibilité d'inscrire 4 autres collaborateurs. A la fin de cette période, chaque collaborateur inscrit et actif sera facturé {collaboratorProduct?.price}€ HT / an.
                </Text>
            </Box>
        </VStack>
    );
};